import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_ANIMATION_DURATION, PROPS_BY_TRANSITION, TRANSITIONS_BY_ANIMATION, ANIMATION_STATUS, TRANSITION_TYPE_TO_PROPERTY_NAME, BLUR_IN_TRANSITION, BLUR_OUT_TRANSITION, HEIGHT_TRANSITION, ZOOM_TRANSITION } from '../animation.constants';
var ANIMATING = ANIMATION_STATUS.ANIMATING,
  PRE_ANIMATING = ANIMATION_STATUS.PRE_ANIMATING,
  SERVER_SIDE = ANIMATION_STATUS.SERVER_SIDE,
  NO_ANIMATION = ANIMATION_STATUS.NO_ANIMATION;
export function getAnimationWithDefaults() {
  var animation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = animation || {},
    name = _ref.name,
    duration = _ref.duration,
    _ref$transitionProps = _ref.transitionProps,
    transitionProps = _ref$transitionProps === void 0 ? {} : _ref$transitionProps,
    _ref$targetSelector = _ref.targetSelector,
    targetSelector = _ref$targetSelector === void 0 ? '' : _ref$targetSelector;
  if (_isEmpty(animation) || _isEmpty(name)) {
    return {};
  }
  return {
    name: name,
    duration: duration || DEFAULT_ANIMATION_DURATION,
    transitionProps: transitionProps,
    targetSelector: targetSelector
  };
}
export function getTransitionPropsWithDefaults(transition, transitionProps) {
  var defaultProps = PROPS_BY_TRANSITION[transition];
  return _objectSpread(_objectSpread({}, defaultProps), transitionProps);
}
export function getTransitions(animationName) {
  return TRANSITIONS_BY_ANIMATION[animationName] || [];
}
export function getStylesForTransitionProps(transition, status) {
  var transitionProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var prevStatus = arguments.length > 3 ? arguments[3] : undefined;
  var props = getTransitionPropsWithDefaults(transition, transitionProps[status] || {});
  if (transition === BLUR_OUT_TRANSITION) {
    if (status === ANIMATING) {
      return {
        opacity: +props.opacity,
        filter: "blur(".concat(props.blur, ")")
      };
    }
  }
  if (transition === BLUR_IN_TRANSITION) {
    if (status === ANIMATING) {
      return {
        opacity: +props.opacity,
        filter: "blur(".concat(props.blur, ")")
      };
    }
  }
  if (transition === HEIGHT_TRANSITION) {
    return {
      height: props.height,
      overflow: props.overflow
    };
  }
  if (transition === ZOOM_TRANSITION) {
    var animationWontRun = status === NO_ANIMATION && prevStatus === SERVER_SIDE;
    var nonAnimatedStatus = [PRE_ANIMATING, SERVER_SIDE].includes(status);
    return {
      transform: "scale(".concat(props.scale, ")"),
      transition: animationWontRun || nonAnimatedStatus ? 'none' : undefined
    };
  }
  return {};
}
export function getTransition(duration, easing) {
  var propertyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
  var transition = "".concat(propertyName, " ").concat(duration, "ms ").concat(easing);
  if (duration === 0) {
    transition = 'none';
  }
  return transition;
}
export function getPropertyNameForTransitionType(transitionType) {
  return _get(TRANSITION_TYPE_TO_PROPERTY_NAME, transitionType, 'all');
}